jQuery(document).ready(function() {
	jQuery('.compliance-level .ginput_container input').val(function() {
        return this.value + '%';
	});
	jQuery('.compliance-level .ginput_container input').change(function() {

		var percentage = this.value;

		if (percentage == 0) {
			jQuery(this).attr('style', 'width: 100% !important');
			jQuery(this).addClass('zero');
		} else if (percentage == 100) {
			jQuery(this).attr('style', 'width: ' + percentage + '% !important');
			jQuery(this).addClass('compliant');
		} else {
			jQuery(this).attr('style', 'width: ' + percentage + '% !important');
			jQuery(this).removeClass('zero');
			jQuery(this).removeClass('compliant');
		}

	    jQuery(this).val(function() {
	        return percentage + '%';
	    });

		var bottom = jQuery(this).parents().next('.bottom-marker').get(0);
		bottom.scrollIntoView({
		    block: "end",
		    behavior: "smooth"
		});

	});
});